module.exports = __webpack_public_path__ + "media/images/invitacion-47c9fe7a4d07d589b64896f3a74f3348.svg";